"use client"

import { cn } from "@litonarefin/utils";
import { useTocActive } from "./TocActiveProvider";

const SideTableOfContentAnchor = ({ anchorId, text }) => {
  const { activeId, setActiveId } = useTocActive();

  return (
    <a
      href={`#${anchorId}`}
      className={cn(
        "jlt-select-none jlt-transition-all jlt-duration-150",
        activeId === anchorId
          ? "jlt-text-[var(--primary)] jlt-font-bold jlt-underline"
          : "hover:jlt-text-[var(--primary)] hover:jlt-underline"
      )}
      onClick={(e) => {
        e.preventDefault();
        const element = document.getElementById(anchorId);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
          // Highlight straight away; the scroll listener takes over once the
          // smooth scroll settles.
          setActiveId(anchorId);
        }
      }}
    >
      {text}
    </a>
  );
};

export default SideTableOfContentAnchor;
